/**
 * @Author: Ygm
 * @Date: 2024-12-05 20:03:40
 * @LastEditors: Ygm
 * @LastEditTime: 2025-01-10 09:45:40
 * @Description: md5加密
 */
import CryptoJS from 'crypto-js'

/**
 * @description md5注释
 * @param string{string} 加密密码
 * @param bit{number} 字节
 * @returns {string}
 */
export default function md5(string, bit) {
  if (!string) return ''
  return CryptoJS.MD5(string).toString(CryptoJS.enc.Hex)
}



// WEBPACK FOOTER //
// ./src/utils/md5Encrypt.js